export default "__VITE_ASSET__3df2d324__"